// Модалки от фансибокса
window.fbx = require('@fancyapps/ui/dist/fancybox.esm');

// Local
// Bootstrap
export { default as Alert } from './boot/js/alert'
export { default as Button } from './boot/js/button'
export { default as Carousel } from './boot/js/carousel'
export { default as Collapse } from './boot/js/collapse'
export { default as Dropdown } from './boot/js/dropdown'
export { default as Modal } from './boot/js/modal'
export { default as Offcanvas } from './boot/js/offcanvas'
export { default as Popover } from './boot/js/popover'
export { default as ScrollSpy } from './boot/js/scrollspy'
export { default as Tab } from './boot/js/tab'
export { default as Toast } from './boot/js/toast'
export { default as Tooltip } from './boot/js/tooltip'

// Vegas
export { default as VegasMask } from './vegas/js/mask';
export { default as VGModal } from './vegas/js/modal';
export { default as VGCarousel } from './vegas/js/carousel';
export { default as VGMap } from './vegas/js/map';
export { default as VegasUI } from './vegas/js/_ui';